import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web'
import config from '../config';

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.AppInsightsInstrumentationKey,
    enableAutoRouteTracking: true,
    distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains: [
      // to avoid extra headers getting passed into '...auth0.com/oauth/token' call
      '*.auth0.com',
      'beta-keycloak-elestio.firepuma.com',
      'keycloak.firepuma.com',
      'auth.firepuma.com',
    ],
    disableTelemetry: !config.AppInsightsEnabled,
  }
});

export const initializeAppInsights = function () {
  appInsights.loadAppInsights()
}



// WEBPACK FOOTER //
// ./src/plugins/appInsights.js